import { Component, Input } from '@angular/core';

/**
 * A single tab pane to be used inside an `app-tabs` container.
 *
 * Displays its content only when active. Activation is controlled by the parent `TabsComponent`.
 *
 * Usage:
 * ```html
 * <app-tab title="Details">
 *   <p>Tab content goes here.</p>
 * </app-tab>
 * ```
 */
@Component({
  selector: 'app-tab',
  imports: [],
  templateUrl: './tab.component.html',
  styleUrl: './tab.component.css',
})
export class TabComponent {
  /**
   * The display title for the tab header.
   */
  @Input() public title?: string;

  /**
   * Indicates whether this tab is currently active (visible).
   * Controlled by the parent `TabsComponent`.
   */
  public active: boolean = false;

  /**
   * Activates this tab, making it visible.
   */
  public activate(): void {
    this.active = true;
  }

  /**
   * Deactivates this tab, hiding its content.
   */
  public deactivate(): void {
    this.active = false;
  }
}
